import React from 'react';

const MessageInput = ({ onSendMessage }) => {
  const [inputText, setInputText] = React.useState('');

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSend();
    }
  };

  const handleSend = () => {
    if (inputText.trim()) {
      onSendMessage(inputText);
      setInputText('');
    }
  };


  return (
    <div className="message-input-container">
      <div className="flex flex-col w-full">
        <div className="flex w-full gap-3">
          <input
            type="text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyPress={handleKeyPress}
            className="message-input"
            placeholder="Écris ton message..."
          />
          <button className="send-button" onClick={handleSend}>
            <i className="fas fa-paper-plane text-white"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MessageInput;